import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchEnquries } from '../../services/enquiry';

export const getEnquries = createAsyncThunk(
    'enquiry/getEnquries',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await fetchEnquries(data, token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch users');
      }
    }
  );
  